import PropTypes from 'prop-types';
import classnames from 'classnames';

const AvailableOptions = ({ options, selectedOption, setSelectedOption }) => (
  <div className="d-flex justify-content-center">
    <div className="d-flex border rounded p-1 text-center mw-100">
      {options.map(({ routeId, name }) => (
        <button
          type="button"
          className={classnames('timetable__option-button btn', {
            'btn-primary': routeId === selectedOption,
          })}
          key={routeId}
          onClick={() => setSelectedOption(routeId)}
          title={name}
        >
          {name}
        </button>
      ))}
    </div>
  </div>
);

AvailableOptions.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      routeId: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  selectedOption: PropTypes.number,
  setSelectedOption: PropTypes.func,
};

export default AvailableOptions;
